import { Component, Inject } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { ToastrService } from 'ngx-toastr'
import { environment } from 'src/environments/environment'
import { FincartService } from 'src/app/e-commerce/fin-cart/fincart.service'
import { AppSettingsService } from 'src/app/settings/services/app-settings.service'
import { BuilderService } from 'src/app/builder-services/builder.service'
import { DiscordService } from 'src/app/builder-services/discord.service'

@Component({
  selector: 'app-fincart-integrate-dialog',
  templateUrl: './fincart-integrate-dialog.component.html',
  styleUrl: './fincart-integrate-dialog.component.scss'
})
export class FincartIntegrateDialogComponent {
  formData = {
    name: '',
    email: '',
    phone: '',
    avg_monthly_orders: '',
    brand: '',
    industry: ''
  }

  industries: string[] = [
    'Fashion & Apparel',
    'Jewelery & Accessories',
    'Beauty & Personal Care',
    'Perfumes',
    'Electronics',
    'Books & Stationery',
    'Home Accessories'
  ]

  avgMonthlyOrders: string[] = [
    'Less than 50 orders',
    '50 - 100 Monthly orders',
    '100 - 300 Monthly orders',
    '300 - 600 Monthly orders',
    '600 - 1000 Monthly orders',
    'More than 1000 orders'
  ]

  submitting: boolean = false
  private fincartBaseUrl = environment.fincartBaseUrl

  constructor(
    public dialogRef: MatDialogRef<FincartIntegrateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private http: HttpClient,
    private toastrService: ToastrService,
    private fincartService: FincartService,
    private appSettingsService: AppSettingsService,
    private builderService: BuilderService,
    private discord: DiscordService
  ) {}

  close(): void {
    this.dialogRef.close()
  }

  isFormValid(): boolean {
    return !!(
      this.formData.name &&
      this.formData.email &&
      this.formData.phone &&
      this.formData.avg_monthly_orders &&
      this.formData.brand &&
      this.formData.industry
    )
  }

  submit(): void {
    if (!this.isFormValid()) {
      this.toastrService.error('Please fill in all fields', 'Error')
      return
    }

    this.submitting = true

    const fincartApiUrl = this.fincartBaseUrl + '/merchant/get-started'
    const url = environment.proxyUrl + encodeURIComponent(fincartApiUrl)
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    })

    const body = {
      name: this.formData.name,
      email: this.formData.email,
      phone: this.formData.phone,
      avg_monthly_orders: this.formData.avg_monthly_orders,
      brand: this.formData.brand,
      industry: this.formData.industry,
      'x-lead-api-key': environment.fincartLeadApiKey
    }

    this.http.post<any>(url, body, { headers }).subscribe({
      next: (res) => {
        console.log(res)
        this.submitting = false
        this.toastrService.success('Your request has been submitted successfully. Fincart will contact you soon!', 'Success')

        this.fincartService.upsertFincartLead(this.formData)

        this.appSettingsService.upsertSettingsByType(String(this.builderService.selectedProject), 'general_settings', { registeredFincart: 'true' }).then(() => {
          this.dialogRef.close(true)
        })

        const discordEmbed = {
          title: '📝 New Fincart Form Submission',
          color: 0x5865F2,
          fields: [
            {
              name: '👤 User Information',
              value: `Name: ${this.formData.name}\n**Email:** ${this.formData.email}\n**Phone:** ${this.formData.phone}`,
              inline: false
            },
            {
              name: '🏪 Business Information',
              value: `Brand: ${this.formData.brand}\n**Industry:** ${this.formData.industry}\n**Avg Monthly Orders:** ${this.formData.avg_monthly_orders}`,
              inline: false
            },
            {
              name: '🔗 Project',
              value: `Project ID: ${this.builderService.selectedProject}`,
              inline: false
            }
          ],
          footer: { text: 'Fincart Lead Form' },
          timestamp: new Date().toISOString()
        }

        this.discord.sendEmbed(discordEmbed, 'Fincart Bot', true).subscribe()
      },
      error: (err) => {
        this.submitting = false
        this.toastrService.error('Failed to submit request. Please try again.', 'Error')
        console.error('Fincart integration error:', err)
      }
    })
  }
}
